<template>
  <div class="courseItem" @click="trigger">
    <!--奖牌图标-->
    <slot></slot>
    <div v-if="course.teacherImage" class="courseItem-avatar">
      <img class="courseItem-avatar" :src="course.teacherImage" alt="avatar"/>
      <img class="courseItem-icon-isGroup" v-if="isGroupShow" src="@assets/icons/group.png" alt="">
      <div class="courseItem-avatar-vip" v-if="course.vipExclusiveFlag">VIP</div>
    </div>
    <div v-if="!course.teacherImage" class="courseItem-avatar holder"/>

    <div class="courseItem-detail">

      <h3 class="courseItem-detail-title" :class="{holder: !course.name}" style="line-height: 1.5;font-weight: bold">
        {{ course.name}}
      </h3>

      <!-- <div v-if="description.length === 1 || !description">
        <h4 class="courseItem-detail-sub" :class="{holder: !course.teacherTitle && !course.teacher}">
          {{ course.teacherTitle || course.teacher }}
        </h4>

        <h5 class="courseItem-detail-desc" :class="{holder: !course}">
          {{ course.description }}
        </h5>
      </div> -->
      <!--限时秒杀限时倒计时-->
      <template v-if="isLimit">
        <h5 class="courseItem-detail-desc" v-if="endSeconds">
          距离结束仅剩
          <!--<span v-for="item in endSeconds"></span>-->
          <span class="courseItem-countdown" v-html="disCountEndTime"></span>
        </h5>
        <h5 class="courseItem-detail-desc">已抢{{course.count}}件</h5>
      </template>
      <h5 class="courseItem-detail-desc"
          v-else
          :class="{holder: !course}"
          v-for="(text, index) in description.slice(0, 2)"
          :key="index">
        {{ text }}
      </h5>


      <div v-if="!course.isDefault && (course.price || course.price === 0) && !isLimit" class="courseItem-detail-price">
        <i v-if="isVipShow" class="courseItem-detail-price-discountTag">会员{{ (new Number(course.vipDiscount * 10)).toFixed(1)}}折</i>
        <i v-if="isGroupShow" class="courseItem-detail-price-groupTag"><span>拼课</span><span> ￥{{ course.groupPrice }}</span></i>
        <!-- <i v-if="course.groupPrice" class="courseItem-detail-price-group"><span></span>￥{{course.groupPrice}}</i> -->
        <i class="courseItem-detail-price-effective">￥{{ showPrice }} </i>
        <del v-if="isVip" class="courseItem-detail-price-origin">￥{{ course.price }}</del>
        <i class="courseItem-detail-price-followed"> | {{ course.count }}人已订阅</i>
      </div>
      <!--限时秒杀栏限时价格-->
      <div class="courseItem-detail-price" v-if="isLimit">
        <i v-if="course.isGroup" class="preferential-price">￥{{course.groupPrice}} &nbsp;</i>
        <i v-else class="preferential-price">￥{{course.price}} &nbsp;</i>
        <del class="courseItem-detail-price-origin">￥{{course.marketPrice}}</del>
      </div>
      <div v-if="course.isDefault || (!course.price && course.price !== 0)" class="courseItem-detail-price holder"/>
    </div>
  </div>
</template>

<script>
  import { delTime } from '../lib/dateUtils'
  import os from '@edu-fe/os'

  export default {
    name: 'CourseItem',

    data () {
      return {
        pingAble: (navigator.userAgent.toLowerCase().match(/MicroMessenger/i))=="micromessenger",
        disCountEndTime: '<span>00</span>:<span>00</span>:<span>00</span>',
        timer: ''
        // disSec: 10,
        // disCountShow: false
      }
    },

    props: {
      course: {
        type: Object,
        default: () => {
          return {
            imageM: '',
            title: '',
            isDefault: true,
            description: ''
          }
        }
      },
      marketId: {
        type: Number | String,
        default: ''
      },
      isLimit: {
        type: Boolean,
        default: false
      }
    },

    computed: {
      description () {
        return this.course.description ? this.course.description.split('\n') : ''
      },
      isVip () {
        return this.course.vipDiscount > 0 && this.course.vipDiscount < 1
      },
      showPrice () {
        if (this.isVip) { // 会员
          return this.course.vipPrice
        } else {
          return this.course.price
        }
      },
      isGroupShow () {
        return this.pingAble && this.course.isGroup
      },
      isVipShow () {
        return (!this.pingAble&&this.isVip) || (this.isVip&&!this.course.isGroup)
      },
      endSeconds () {
        return this.course.endSeconds
      },
      isIosApp () {
        if (os.type === 'app') {
          if (os.name === 'ios') {
            return true
          }
        }
        return false
      },
    },
    filters: {
      delTime: delTime
    },
    watch: {
      endSeconds: {
        handler (val) {
          if (!val) return
          let discountSec = val * 1000
          this.timer = setInterval(() => {
            discountSec -= 1000
            // console.log(val)
            this.setDate(discountSec)
          }, 1000)

        },
        immediate: true
      },
      // disCountShow: {
      //   handler (val) {
      //     if (val) {
      //       setInterval(() => {
      //         if (this.disSec > 0) {
      //           this.disSec -= 1
      //         } else {
      //           this.disSec = 10
      //         }
      //       }, 80)
      //     }
      //   },
      //   immediate: true
      // }
    },
    methods: {
      trigger () {
        if (this.isIosApp) {
          return os.sdk.view.goto('sign-up', { courseId: this.course.id})
        }
        
        this.$emit('click')
        this.$router.push({ name: 'sign-up', query: { courseId: this.course.id , market: this.marketId || this.$route.query.market} })
      },
      setDate (date) {
        let hour = parseInt(date/1000/60/60)
        let min = parseInt((date - hour*1000*60*60) /1000/ 60)
        let sec = parseInt((date - hour*1000*60*60 - min*1000*60)/1000)
        // this.disCountShow = true
        this.disCountEndTime = `<span style="background: #FFF5DE;">${delTime(hour)}</span>:
                              <span style="background: #FFF5DE;">${delTime(min)}</span>:
                              <span style="background: #FFF5DE;">${delTime(sec)}</span>`
      }
    },

    created () {
      // console.log(this.course)
    },
    beforeDestroy () {
      clearInterval(this.timer)
    }
  }
</script>

<style lang="scss" scoped>
  @charset "UTF-8";
  @import "../style/main";

  $global-width: 750;

  // for sketelon design
  .holder {
    background: linear-gradient(to right, rgba(0,0,0,0) 0%,rgba(0,0,0,0) 1%,rgba(0,0,0,0.25) 100%);
    background-size: 200% 100%;
    background-position: 0 0;
    animation: inkwell 1200ms linear infinite;
  }

  @keyframes inkwell {
    0% { background-position: 0 0; }
    50% { background-position: 50% 0; }
    100% { background-position: 0 0; }
  }

  .courseItem {
    position: relative;
    height: rem(250);
    width: rem(665);
    padding: rem(30);
    box-sizing: border-box;
    &-countdown {
      color: #FF634A;

      >span {
        display: inline-block;
        color: #FF634A;
        background: #FFF5DE;
        padding: rem(3);
      }
    }
    &-icon {
      &-isGroup {
        position: absolute;
        top: 0;
        left: 0;
        width: rem(60) !important;
        height: rem(62) !important;
      }
    }

    &-avatar {
      position: relative;
      float: left;
      height: rem(190);
      width: rem(155);
      border-radius: rem(6);
      margin-right: rem(30);
      overflow: hidden;
      &-vip {
        position: absolute;
        font-size: rem(20);
        width: rem(40);
        line-height: rem(20);
        height: rem(20);
        background-color: #FF4F59;
        text-align: center;
        color: #fff;
        border-radius: rem(4);
        right: rem(5);
        top: rem(5);
      }
      img {
        height: 100%;
        width: 100%;
      }

      &.holder {
        background-color: #dfdfdf;
      }
    }

    &-detail {
      position: relative;
      float: left;
      height: rem(190);
      width: rem(420);

      .holder {
        background-color: #dfdfdf;
      }

      &-title {
        width: 100%;
        color: #333;
        font-size: rem(30);
        margin-bottom: rem(20);
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        &.holder {
          width: 70%;
          height: rem(30);
        }
      }

      &-sub {
        width: 100%;
        color: #666;
        font-size: rem(24);
        margin-bottom: rem(20);

        &.holder {
          width: 30%;
          height: rem(24);
        }
      }

      &-desc {
        @extend .courseItem-detail-title;
        line-height: 1.2;
        color: #999;
        font-size: rem(24);

        &.holder {
          width: 100%;
          height: rem(24);
        }
      }
      .preferential-price {
        font-size: rem(26);
        color: #FF634A;
      }
      &-price {
        position: absolute;
        bottom: 0;
        left: 0;
        height: rem(24);
        line-height: rem(24);
        width: 100%;
        &.holder {
          height: rem(24);
          background-color: #dfdfdf;
        }

        &-discountTag {
          float: left;
          height: rem(22);
          text-align: center;
          color: #fff;
          font-size: rem(20);
          letter-spacing: rem(2);
          line-height: rem(22);
          text-indent: rem(2);
          background-color: #ED4040;
          vertical-align: middle;
          overflow: hidden;
        }

        &-groupTag {
          display: inline-block;
          text-align: left;
          height: rem(24);
          font-size: rem(18);
          border: rem(1) solid #ED4040;
          line-height: rem(24);
          box-sizing: border-box;
          background-color: #FFEAEA;
          vertical-align: middle;
          margin-top: rem(-4);

          span {
            display: inline-block;
            text-align: center;

            &:first-child{
              color: #fff;
              background-color:#ED4040;
            }

            &:last-child {
              color: #ED4040;
            }
          }
        }

        &-effective {
          color: #F48F00;
          font-size: rem(26);

          .holder {
            height: rem(24);
            background-color: #dfdfdf;
          }
        }

        &-origin {
          color: #999;
          font-size: rem(20);

          .holder {
            height: rem(24);
            background-color: #dfdfdf;
          }
        }

        &-followed {
          color: #999;
          font-size: rem(24);

          .holder {
            height: rem(24);
            background-color: #dfdfdf;
          }
        }
      }
    }
  }
</style>
